const breadcrumbsSchema = {
  orders: {
    name: "Zamówienia",
    children: {
      uid: {
        name: "dynamic",
        key: ["firstName", "lastName"]
      }
    }
  },
  pagesLists: {
    name: "Listy stron",
    children: {
      uid: {
        name: "dynamic",
        key: ["name"],
        children: {
          uid: {
            name: "propsPath",
            collection: "pagesLists",
            key: [
              {
                type: "static",
                name: "pagesLists"
              },
              {
                type: "static",
                name: "entities"
              },
              {
                type: "propsPath",
                collection: "params",
                key: [
                  {
                    type: "static",
                    name: "slug"
                  }
                ]
              },
              {
                type: "static",
                name: "pages"
              },
              {
                type: "propsPath",
                collection: "params",
                key: [
                  {
                    type: "static",
                    name: "uid"
                  }
                ]
              },
              {
                type: "static",
                name: "pageTranslations"
              },
              {
                type: "propsPath",
                collection: "locales",
                key: [
                  {
                    type: "static",
                    name: "locales"
                  },
                  {
                    type: "static",
                    name: "defaultLocale"
                  }
                ]
              },
              {
                type: "static",
                name: "name"
              }
            ]
          }
        }
      }
    }
  },
  menus: {
    name: "Menu",
    children: {
      uid: {
        name: "propsPath",
        collection: "menus",
        key: [
          {
            type: "static",
            name: "menus"
          },
          {
            type: "static",
            name: "entities"
          },
          {
            type: "propsPath",
            collection: "params",
            key: [
              {
                type: "static",
                name: "placeholder"
              }
            ]
          },
          {
            type: "static",
            name: "menuTranslations"
          },
          {
            type: "propsPath",
            collection: "locales",
            key: [
              {
                type: "static",
                name: "locales"
              },
              {
                type: "static",
                name: "defaultLocale"
              }
            ]
          },
          {
            type: "static",
            name: "name"
          }
        ]
      }
    }
  },
  fieldCategories: {
    name: "Ustawienia",
    children: {
      uid: {
        name: "propsPath",
        collection: "fieldCategories",
        key: [
          {
            type: "static",
            name: "fieldCategories"
          },
          {
            type: "static",
            name: "entities"
          },
          {
            type: "propsPath",
            collection: "params",
            key: [
              {
                type: "static",
                name: "placeholder"
              }
            ]
          },
          {
            type: "static",
            name: "fieldCategoryTranslations"
          },
          {
            type: "propsPath",
            collection: "locales",
            key: [
              {
                type: "static",
                name: "locales"
              },
              {
                type: "static",
                name: "defaultLocale"
              }
            ]
          },
          {
            type: "static",
            name: "name"
          }
        ]
      }
    }
  },
  mediaCategories: {
    name: "Media",
    children: {
      uid: {
        name: "dynamic",
        key: ["name"]
      }
    }
  },
  invoices: {
    name: "Faktury",
    children: {
      add: {
        name: "Nowa faktura"
      },
      uid: {
        name: "dynamic",
        key: ["invoiceNr"]
      }
    }
  }
};

export function getObject(object, element) {
  if (object == undefined) {
    return breadcrumbsSchema[element];
  } else {
    let el = object.children[element];
    if (el !== undefined) {
      return el;
    } else {
      return object.children["uid"];
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/app/breadcrumbs.js